import { useMemo } from "react"

import createStore from "@Stores/base-factories"
import { hookOrganizationList } from "@Stores/base-factories/store-list"
import hookSiteSelectedFactory from "@Stores/base-factories/store-site-selection"

const useSiteFactory = ({ fetch, siteSelected: { id: siteId } }) => useMemo(() => ({
  listVerifications: async () => await fetch({
    url: 'verifications',
    params: { siteId },
  }),
}), [fetch, siteId])

const { Provider, useStore } = createStore()
  .extend(hookSiteSelectedFactory('siteId'))
  .extendHookCollectionFactory('site')
  .extendHookCollectionsFactory('sites')
  .extend(hookOrganizationList())
  .extend(useSiteFactory)
  .factory()

export {
  Provider as SiteProvider,
  useStore as useSiteStore,
}
